<template>
  <vs-prompt
    :title="editText"
    :accept-text="$t('Submit')"
    :cancel-text="$t('Cancel')"
    button-cancel="border"
    @cancel="removeTodo"
    @accept="submitTodo"
    :is-valid="validateForm"
    :active.sync="activePrompt"
  >
    <div id="prompt-edit">
      <form>
        <ValidationObserver ref="observer">
          <div class="vx-row">
            <div v-if="allowComplete" class="vx-col w-1/6 self-center">
              <vs-checkbox
                v-model="taskLocal.isCompleted"
                class="w-8"
              ></vs-checkbox>
            </div>

            <div v-if="displayStatus" class="vx-col ml-auto flex">
              <vs-dropdown class="cursor-pointer flex" vs-custom-content>
                <div class="status-icon" :class="`bg-${getStatusColor(taskLocal.status)}`">
                  <feather-icon :icon="getStatusIcon(taskLocal.status)" svgClasses="text-white stroke-current w-5 h-5" />
                </div>
                <vs-dropdown-menu style="z-index: 200001">
                  <vs-dropdown-item
                    @click.stop
                    v-for="(tag, index) in taskTags"
                    :key="index"
                  >
                    <vs-radio v-model="taskLocal.status" :vs-value="tag.value">{{ $t('KPU.KPUStatus.' +  tag.value) }}</vs-radio>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <ValidationProvider :name="$t('KPU.ToDo.Name')" rules="required" v-slot="{ errors }">
                <validated-input
                    :label="$t('KPU.ToDo.Name')"
                    v-model="taskLocal.name"
                    :disabled="disableTitle"
                  ></validated-input>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
              <vs-textarea class="mt-5"
                rows="5"
                :label="$t('KPU.ToDo.Description')"
                v-model="taskLocal.desc"
              />
            </div>
          </div>
          <div v-if="displayDueDate" class="vx-row">
            <div class="vx-col w-full">
              <form-label>{{$t('KPU.ToDo.DueDate')}}</form-label>
              <ValidationProvider :name="$t('KPU.ToDo.DueDate')" rules="required" v-slot="{ errors }">
                <datepicker format="yyyy-MM-dd"
                            :placeholder="$t('KPU.ToDo.DueDate')"
                            v-model="taskLocal.dueDate"></datepicker>
                <validation-message>{{ errors[0] }}</validation-message>
              </ValidationProvider>
            </div>
          </div>
        </ValidationObserver>
      </form>
    </div>
  </vs-prompt>
</template>

<script>
import KPUStatusEnum from './../KPUStatusEnum.js'
import Datepicker from 'vuejs-datepicker'
import {
  FormLabel,
  ValidationMessage,
  ValidatedInput
} from "../../../shared/components";

export default {
  components: {
    FormLabel,
    Datepicker,
    ValidationMessage,
    ValidatedInput
  },
  props: {
    displayPrompt: {
      type: Boolean,
      required: true
    },
    taskId: {
      type: String,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    editText : {
      type: String,
      default : "Edit"
    },
    displayDueDate : {
      type: Boolean,
      default: false
    },
    displayStatus : {
      type: Boolean,
      default: true
    },
    canEditTitle :  {
      type:Boolean,
      default : true
    },
    allowComplete : {
      type:Boolean,
      default : true
    }
  },
  data() {
    return {
      taskLocal: Object.assign({}, this.task),
      tags: [
        {
          id: KPUStatusEnum.Ok,
          value : KPUStatusEnum.Ok,
          icon : 'ThumbsUpIcon',
          color: 'success'
        },
        {
          id: KPUStatusEnum.Warning,
          value : KPUStatusEnum.Warning,
          icon : 'AlertTriangleIcon',
          color: 'warning'
        },
        {
          id: KPUStatusEnum.BehindTarget,
          value : KPUStatusEnum.BehindTarget,
          icon : 'AlertOctagonIcon',
          color: 'danger'
        }
      ]
    };
  },
  computed: {
    activePrompt: {
      get() {
        return this.displayPrompt;
      },
      set(value) {
        this.$emit("hideDisplayPrompt", value);
      }
    },
    taskTags() {
      return this.tags;
    },
    validateForm() {
      return this.taskLocal.name !== "" && (!this.$props.displayDueDate || this.taskLocal.dueDate !== null);
    },
    disableTitle() {
      return !this.$props.canEditTitle;
    }
  },
  methods: {
    getStatusIcon (status) {
      return this.tags.find(t => t.id === status).icon;
    },
    getStatusColor (status) {
      return this.tags.find(t => t.id === status).color;
    },
    removeTodo() {
      this.$emit("delete", this.taskLocal);
    },
    submitTodo() {
      this.$emit("submit", this.taskLocal);
    }
  }
}
</script>
<style lang="scss">
#prompt-edit {
  .status-icon {
      border-radius: 50%;
      padding: .75rem;
      padding-bottom: 0.4rem;
  }
}
</style>
